import UserDealerMappedResponse, { getDefaultState as getDefaultUserSettingsMappedData } from './userDealerMappedResponse';
import t from 'tcomb';

const UserDelearDataCollections = t.list(UserDealerMappedResponse, 'UserDealerMappedResponse');

export const getDefaultState = () => new UserDelearDataCollections(
    [getDefaultUserSettingsMappedData()],
);

export default UserDelearDataCollections;
